import { forwardRef, useId } from "react";

import { FormHelperText } from "@mui/material";

import { useTimeField } from "./TimeField.hooks";
import {
  AddonWrapper,
  Container,
  InputWrapper,
  StylesTimeField,
} from "./TimeField.styles";
import { TimeFieldProps, TimeFieldReference } from "./TimeField.types";
import InputLabel from "../InputLabel/InputLabel";

const TextField = forwardRef<TimeFieldReference, TimeFieldProps>(
  (
    {
      label,
      id,
      defaultValue,
      value,
      readOnly,
      fullWidth = true,
      InputProps = {},
      addonBefore,
      addonBeforeProps,
      addonAfter,
      addonAfterProps,
      helperText,
      tooltipText,
      onChange,
      ...innerProps
    },
    ref
  ) => {
    const { timeFieldRef, valueState, onChangeHandler } = useTimeField({
      ref,
      defaultValue,
      value,
      onChange,
    });
    const formId = useId();

    return (
      <Container>
        {!!label && (
          <InputLabel
            htmlFor={id ?? formId}
            required={innerProps.required}
            helperText={tooltipText}
          >
            {label}
          </InputLabel>
        )}
        <InputWrapper fullWidth={fullWidth} color={innerProps.color}>
          {addonBefore ? (
            <AddonWrapper
              placement="before"
              disabled={innerProps.disabled}
              {...addonBeforeProps}
            >
              {addonBefore}
            </AddonWrapper>
          ) : null}
          <StylesTimeField
            withAddonBefore={!!addonBefore}
            withAddonAfter={!!addonAfter}
            id={id ?? formId}
            variant="outlined"
            size="small"
            ref={timeFieldRef}
            fullWidth={fullWidth}
            value={valueState}
            onChange={onChangeHandler}
            InputProps={{
              readOnly,
              ...InputProps,
            }}
            {...innerProps}
          />
          {addonAfter ? (
            <AddonWrapper
              placement="after"
              disabled={innerProps.disabled}
              {...addonAfterProps}
            >
              {addonAfter}
            </AddonWrapper>
          ) : null}
        </InputWrapper>
        {helperText ? (
          <FormHelperText
            variant="outlined"
            required={innerProps.required}
            error={innerProps.error}
            disabled={innerProps.disabled}
          >
            {helperText}
          </FormHelperText>
        ) : null}
      </Container>
    );
  }
);

export default TextField;
